import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface QRCodeReaderProps {
  onScan: (val: string | null) => void;
}

const QRCodeReader: React.FC<QRCodeReaderProps> = ({ onScan }) => {
  const [qrData, setQrData] = useState<string | null>(null);
  const [scanner, setScanner] = useState<Html5QrcodeScanner | null>(null);
  const [isScanning, setIsScanning] = useState<boolean>(false);
  const [isCameraAvailable, setIsCameraAvailable] = useState<boolean>(true);

  useEffect(() => {
    // Check browser camera support
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setIsCameraAvailable(false);
    }
  }, []);

  useEffect(() => {
    if (isScanning && isCameraAvailable) {
      // Ensure the scanner initializes only when the `#reader` div is in the DOM
      setTimeout(() => {
        const newScanner = new Html5QrcodeScanner(
          "reader",
          {
            qrbox: { width: 250, height: 250 },
            fps: 10,
          },
          false
        );

        newScanner.render(
          (result: string) => {
            newScanner.clear();
            setQrData(result);
            onScan(result);
            setIsScanning(false);
          },
          (error: any) => {
            console.warn("QR Scan Error:", error);
          }
        );

        setScanner(newScanner);
      }, 500); // Delay to ensure element exists
    }

    return () => {
      // Cleanup scanner instance when stopping
      if (scanner) {
        scanner.clear();
        setScanner(null);
      }
    };
  }, [isScanning, isCameraAvailable]);

  return (
    <div className="position-relative">
      {qrData && <div>Scanned Data: {qrData}</div>}

      {!isScanning ? (
        <button onClick={() => setIsScanning(true)}>Open Camera</button>
      ) : (
        <button onClick={() => setIsScanning(false)} className="position-absolute close-camera">
          <CloseOutlinedIcon />
        </button>
      )}

      {isScanning && isCameraAvailable && <div id="reader" className="reader border-0"></div>}

      {!isCameraAvailable && (
        <p style={{ color: "red" }}>
          Camera access is not supported in this browser or context. Please use a supported browser.
        </p>
      )}
    </div>
  );
};

export default QRCodeReader;